import React, { useEffect, useState } from 'react';

import RadioGroupComp from '../../../../common/components/RadioGroup/RadioGroupComp';

import TimeComp from './TimeComp';

interface IDailyProps {
	skipWeekend: boolean;
	startsAtHour: string | number;
	startsAtMinutes: string | number;
}

interface IDailyCompProps {
	handleChange: (val: IDailyProps) => void;
}

const dailySelection = [
	{ value: 'everyday', label: 'Everyday' },
	{ value: 'weekday', label: 'Every weekday' },
];

const DailyComp = (props: IDailyCompProps) => {
	const { handleChange } = props;

	const [hour, setHour] = useState<string | number>('12');
	const [minutes, setMinutes] = useState<string | number>('00');
	const [skipWeekend, setSkipWeekend] = useState<boolean>(false);

	const handleDailyChange = (val: string | number) => {
		setSkipWeekend(val === 'weekday');
	};

	const handleHourChange = (val: string | number) => {
		setHour(val);
	};

	const handleMinuteChange = (val: string | number) => {
		setMinutes(val);
	};

	useEffect(() => {
		if (
			skipWeekend !== undefined ||
			hour !== undefined ||
			minutes !== undefined
		) {
			const obj = {
				skipWeekend,
				startsAtHour: hour,
				startsAtMinutes: minutes,
			};
			handleChange(obj);
		}
	}, [skipWeekend, hour, minutes]);

	return (
		<>
			<RadioGroupComp
				type="string"
				optionSelection={dailySelection}
				defaultValue="everyday"
				handleValueChange={handleDailyChange}
			/>
			<TimeComp
				handleHourChange={handleHourChange}
				handleMinuteChange={handleMinuteChange}
			/>
		</>
	);
};

export default DailyComp;
